import { useEffect, useRef, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

function useCountUp(value, duration = 1200) {
  const [display, setDisplay] = useState(0);
  const prev = useRef(0);
  useEffect(() => {
    const from = prev.current;
    const to = Number(value) || 0;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
      else prev.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return display;
}

export function KpiCard({ title, value, suffix = "", decimals = 0, delta, icon: Icon, testid }) {
  const animated = useCountUp(value);
  const formatted = decimals > 0
    ? animated.toFixed(decimals)
    : Math.round(animated).toLocaleString("en-ZA");
  return (
    <div className="card-surface p-5 relative overflow-hidden group" data-testid={testid}>
      <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full bg-blue-500/10 blur-2xl group-hover:bg-cyan-400/15 transition-colors" />
      <div className="flex items-start justify-between">
        <p className="text-[11px] font-semibold tracking-[0.18em] text-muted-foreground uppercase">{title}</p>
        {Icon && <Icon className="w-4 h-4 text-cyan-400" />}
      </div>
      <p className="mt-3 text-2xl lg:text-3xl font-display font-bold text-white tracking-tight" data-testid={`${testid}-value`}>
        {formatted}{suffix}
      </p>
      {delta !== undefined && delta !== null && (
        <p className={`mt-1.5 text-xs flex items-center gap-1 ${delta >= 0 ? "text-emerald-400" : "text-red-400"}`}>
          {delta >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
          {delta >= 0 ? "+" : ""}{delta}% vs previous period
        </p>
      )}
    </div>
  );
}

export default KpiCard;
